import { render, staticRenderFns } from "./FiltersExpansion.vue?vue&type=template&id=5635d614&scoped=true&"
import script from "./FiltersExpansion.vue?vue&type=script&lang=js&"
export * from "./FiltersExpansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635d614",
  null
  
)

export default component.exports